import * as ActionTypes from 'actions/partnerPlans'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  partnerPlans: [],
  selectedPlan: {},
  planStatus: [],
  planYear: [],
  htmlPage: {},
}

const getPlanStatus = (partnerPlanItems) => {
  const sortedPlanStatus = [...partnerPlanItems].sort((a, b) => ((a.planStatus > b.planStatus) ? 1 : -1))
  const uniquePlanStatus = [...new Set(sortedPlanStatus.map(item => item.planStatus))]
  const planStatusOptions = []
  uniquePlanStatus.map(item =>
    planStatusOptions.push({ value: `${item}`, label: `${item}` }))
  return planStatusOptions
}

const getPlanYear = (partnerPlanItems) => {
  const sortedPlanYear = [...partnerPlanItems].sort((a, b) => ((a.year < b.year) ? 1 : -1))
  const uniquePlanYear = [...new Set(sortedPlanYear.map(item => item.year))]
  const planYearOptions = []
  uniquePlanYear.map(item =>
    planYearOptions.push({ value: `${item}`, label: `${item}` }))
  return planYearOptions
}

// Updates error message to notify about the failed fetches.
export default function partnerPlans(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PARTNERPLANS_GET:
      return {
        ...state,
        isFetching: true,
      }
    // eslint-disable-next-line no-case-declarations
    case ActionTypes.PARTNERPLANS_RECEIVED:
      const planStatus = getPlanStatus(action.partnerPlans)
      const planYear = getPlanYear(action.partnerPlans)
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerPlans: action.partnerPlans,
        planStatus,
        planYear,
      }
    case ActionTypes.PARTNERPLANS_PAGE_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        htmlPage: action.partnerPlanHTMLPage,
      }
    case ActionTypes.PARTNERPLANS_SET_SELECTEDPLAN:
      return {
        ...state,
        selectedPlan: action.plan,
      }
    case ActionTypes.PARTNERPLANS_INIT_HTMLCONTENT:
      return {
        ...state,
        htmlPage: {},
      }
    case ActionTypes.PARTNERPLANSTATUS_SAVE_REQUEST:
      return Object.assign({}, state, {
        // isFetching: true,
      })
    case ActionTypes.PARTNERPLANSTATUS_SAVE_COMPLETE:
      return {
        ...state,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnerPlans.js